class DateTimeHelper {
  calculateDuration(startDateTime, endDateTime) {
    var diff = new Date(endDateTime.getTime() - startDateTime.getTime());
    var yearsDiff = diff.getFullYear() - 1970;
    var monthsDiff = diff.getMonth();
    var dateDiff = diff.getDate();

    var result = "";
    if (yearsDiff > 0) {
      if (yearsDiff > 1) {
        result += yearsDiff + " years ";
      } else {
        result += yearsDiff + " year ";
      }
    }

    if (monthsDiff > 0) {
      if (monthsDiff > 1) {
        result += monthsDiff + " months ";
      } else {
        result += monthsDiff + " month ";
      }
    }

    if (monthsDiff === 0 && yearsDiff === 0) {
      if (dateDiff > 1) {
        return dateDiff + " days ";
      }

      if (dateDiff === 1) {
        return "1 day ";
      }

      return "0 day";
    }

    return result.trim();
  }

  calculateDurationYears(startDateTime, endDateTime) {
    var diff = new Date(endDateTime.getTime() - startDateTime.getTime());
    return diff.getFullYear() - 1970;
  }

  getDateString(date) {
    return (
      this.getShortMonthDisplayName(date) +
      " " +
      date.getDate() +
      " " +
      date.getFullYear()
    );
  }

  getShortMonthDisplayName(date) {
    return date.toLocaleString("en-US", { month: "short" });
  }
}

export default new DateTimeHelper();
